var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnfeiteseta01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 60,
    viewBox: "0 0 580 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 37.5881,
    width: 1088,
    height: 16,
    transform: "rotate(-180 444 37.5881)",
    fill: "#181a27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.196 29.5673L480.888 0.000147519L464.05 0.000145968L489.332 29.5673L489.156 29.7941L505.994 29.7941L506.196 29.5673Z",
    fill: "#181a27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M489.156 29.7941L464 59.21L464.328 59.5881L480.535 59.5881L505.994 29.7941L489.156 29.7941Z",
    fill: "#181a27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M526.058 29.7941L542.921 29.7941L543.098 29.5673L517.791 0.000147519L500.953 0.000145968L526.26 29.5673L526.058 29.7941Z",
    fill: "#181a27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M526.058 29.7941L500.902 59.21L501.23 59.5881L517.438 59.5881L542.921 29.7941L526.058 29.7941Z",
    fill: "#181a27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M562.96 29.7941L579.824 29.7941L580 29.5673L554.718 0.000147521L537.855 0.000145968L563.162 29.5673L562.96 29.7941Z",
    fill: "#181a27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M562.96 29.7941L537.83 59.21L538.132 59.5881L554.34 59.5881L579.824 29.7941L562.96 29.7941Z",
    fill: "#181a27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnfeiteseta01);
export default __webpack_public_path__ + "static/media/ENFEITESETA_01.7c12f7b20a247fe9526902d6674c598b.svg";
export { ForwardRef as ReactComponent };